import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

export enum SiteNavigationSizes {
  Normal = 'normal',
  Collapsed = 'collapsed',
  Small = 'small',
}

const SiteNavigationParts = [
  'container',
  'tabWrapper',
  'footerWrapper',
] as const

const helpers = createMultiStyleConfigHelpers(SiteNavigationParts)

export const SiteNavigationStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignSelf: 'stretch',
      paddingBottom: '0.5rem',
      alignItems: 'flex-start',
      borderRight: '2px solid',
      borderRightColor: 'border.default',
      justifyContent: 'space-between',
      bg: 'bg.panel',
      transition: 'min-width 0.2s ease-out, max-width 0.2s ease-out',
      zIndex: 4,
    },
    tabWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      gap: '0.25rem',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    footerWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignSelf: 'stretch',
      gap: '0.25rem',
    },
  },
  sizes: {
    [SiteNavigationSizes.Normal]: {
      container: {
        minWidth: '11.875rem',
        maxWidth: '15rem',
        paddingX: '0.5rem',
        paddingTop: '0.5rem',
      },
    },
    [SiteNavigationSizes.Collapsed]: {
      container: {
        minWidth: '4rem',
        maxWidth: '4rem',
        alignItems: 'center',
        paddingTop: '0.5rem',
      },
      tabWrapper: {
        alignItems: 'center',
      },
      footerWrapper: {
        alignItems: 'center',
      },
    },
    [SiteNavigationSizes.Small]: {
      container: {
        minWidth: '4rem',
        maxWidth: '4rem',
        alignItems: 'center',
        paddingTop: '0',
      },
      tabWrapper: {
        alignItems: 'center',
      },
      footerWrapper: {
        alignItems: 'center',
      },
    },
  },
  defaultProps: {
    size: SiteNavigationSizes.Normal,
  },
})

export const useSiteNavigationStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(SiteNavigationStyle, props) as MultiStyleType<
    typeof SiteNavigationParts
  >
}
